<div class="no-print container mt-3 mb-1">
  <div class="d-flex justify-content-between align-items-center">
    <div>
      <h3>
        <span class="font-bold"
          >{{ activeSeasonId }}
          {{ 'selectVaccines.season' | cxTranslate }}</span
        >
      </h3>
    </div>
    <div class="d-flex gap-3">
      <span class="c-link" (click)="backToCart()">
        <i class="fa fa-icon fa-chevron-left"></i>
        {{ 'selectVaccines.back_to_db' | cxTranslate }}
      </span>
      <span class="c-link" (click)="downloadExcel()">
        <i class="fa fa-icon fa-file-excel"></i>
        {{ 'selectVaccines.xls' | cxTranslate }}</span
      >
      <span class="c-link" (click)="onFluPrint()">
        <i class="fa fa-icon fa-print"></i>
        {{ 'selectVaccines.print' | cxTranslate }}</span
      >
    </div>
  </div>
</div>
<app-flu-header [selectedHeader]="header"></app-flu-header>
<app-checkout
  [cartDetails]="cartDetails"
  [stdCartType]="stdCart"
  [activeSeasonId]="activeSeasonId"
  [isFluCheckout]="true"></app-checkout>
